<template>
  <v-container>
    <v-card>
      <v-card-title primary-title class="justify-center">
        <v-tabs
          v-model="type"
          grow
          background-color="transparent"
          color="secondary"
          slider-color="secondary"
          @change="loadData()"
        >
          <v-tab class="mr-3" v-for="tipo in typeList" v-bind:key="tipo.code">
            <v-icon class="mr-2"> {{ tipo.icon }}</v-icon>
            {{ tipo.dex }}
          </v-tab>
        </v-tabs>
      </v-card-title>
      <v-card-text>
        <v-layout justify-center style="flex-wrap: wrap">
          <v-radio-group
            row
            justify-center
            v-model="filter"
            @change="loadData()"
          >
            <v-radio label="Tutti" value="all"></v-radio>
            <v-radio label="Tradotti" value="onlyTrad"></v-radio>
            <v-radio label="Da tradurre" value="onlyNotTrad"></v-radio>
          </v-radio-group>
          <v-select
            v-model="lang"
            @change="loadData"
            :items="computedLanguageList"
            item-text="description"
            item-value="language"
            :menu-props="{ maxHeight: '400' }"
            label="lingua"
            required
            color="primary"
            persistent-hint
          ></v-select>
        </v-layout>
        <DataTables
          :headers="headers"
          :footerButtons="footer"
          :itemPerPage="9"
          :tableData="translations"
          @createNewTranslation="openNewTranslation"
          @saveTranslations="saveTranslations"
        ></DataTables>
      </v-card-text>
    </v-card>
    <v-dialog v-model="createTranslationDialog" width="600">
      <v-card>
        <v-card-title style="font-weight: bold">
          Crea nuova traduzione {{ computedTypeText }}
        </v-card-title>
        <v-card-text>
          <div
            style="text-align: center; width: 100%; font-weight: 400"
            v-if="
              computedTypeCode === 'errorMsg' || computedTypeCode === 'backend'
            "
          >
            Usare [?] per le variabili
          </div>
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr v-if="computedTypeCode === 'errorMsg'">
                  <td>Tipo messaggio</td>
                  <td>
                    <v-select
                      v-model="newTranslationSeverity"
                      :items="severityList"
                      item-text="dex"
                      item-value="code"
                      :menu-props="{ maxHeight: '400' }"
                      required
                      color="primary"
                    ></v-select>
                  </td>
                </tr>
                <tr v-else>
                  <td>Chiave messaggio</td>
                  <td>
                    <v-text-field
                      v-model="newTranslationKey"
                      dense
                      hide-details
                    ></v-text-field>
                  </td>
                </tr>
                <tr>
                  <td>Testo messaggio {{ pilotLang.toUpperCase() }}</td>
                  <td>
                    <v-text-field
                      v-model="newTranslationValue"
                      dense
                      hide-details
                    ></v-text-field>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions
          ><v-spacer></v-spacer
          ><v-btn color="primary" @click="createNewTranslation">Crea</v-btn
          ><v-btn color="error" @click="createTranslationDialog = false"
            >Chiudi</v-btn
          ><v-spacer></v-spacer
        ></v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { GChart } from "vue-google-charts";
import DataTables from "@/components/base/DataTables.vue";
import Swal from "sweetalert2";

export default {
  components: { GChart, DataTables },
  name: "mgmt-translations",
  data: () => ({
    translations: [],
    filter: "onlyNotTrad",
    typeList: [
      { code: "errorMsg", dex: "Messaggi d'errore", icon: "mdi-code-json" },
      { code: "backend", dex: "Messaggi backend", icon: "mdi-server" },
      { code: "frontend", dex: "Messaggi frontend", icon: "mdi-monitor" },
    ],
    severityList: [
      { code: 0, dex: "Successo" },
      { code: 1, dex: "Errore applicativo" },
      { code: 2, dex: "Errore sistemistico" },
      { code: 4, dex: "Errore autorizzazione" },
    ],
    type: 0,
    systemData: null,
    lang: null,
    createTranslationDialog: false,
    pilotLang: null,
    newTranslationSeverity: 0,
    newTranslationKey: "",
    newTranslationValue: "",
    headers: [],
    footer: [],
  }),
  computed: {
    computedTypeText() {
      return this.typeList[this.type].dex;
    },
    computedTypeCode() {
      return this.typeList[this.type].code;
    },
    computedLanguageList() {
      let _ = this;
      return systemData.supportedLanguage;
    },
  },
  methods: {
    createNewTranslation: async function () {
      let _ = this;
      let response = _.chiamataAxios(
        "POST",
        "/mgmt/createTranslations/" +
          _.typeList[_.type].code +
          "/" +
          _.pilotLang,
        {
          body: {
            key: _.newTranslationKey,
            value: _.newTranslationValue,
            severity: _.newTranslationSeverity,
          },
          msg: "always",
        }
      );
      if (response.msg.esito) createTranslationDialog = false;
    },
    saveTranslations: function () {
      let _ = this;
      let response = _.chiamataAxios(
        "POST",
        "/mgmt/updateTranslations/" + _.typeList[_.type].code,
        { body: _.translations, msg: "always" }
      );
      if (response.msg.esito) _.loadData();
    },
    openNewTranslation: function () {
      this.newTranslationKey = "";
      this.newTranslationValue = "";
      this.newTranslationSeverity = 0;
      this.createTranslationDialog = true;
    },
    loadData: async function () {
      let _ = this;

      _.headers = [
        { text: "chiave", value: "key", type: "text" },
        {
          text: "Valore " + window.selectedLanguage.toUpperCase(),
          value: "pilotValue",
          type: "text",
        },
        {
          text: "valore " + _.lang.toUpperCase(),
          value: "value",
          type: "inputText",
        },
      ];
      _.footer = [
        {
          text: "Crea nuova traduzione",
          icon: "mdi-plus",
          action: "createNewTranslation",
          color: "primary",
        },
        {
          text: "Salva modifiche",
          icon: "mdi-content-save",
          action: "saveTranslations",
          color: "primary",
        },
      ];
      let response = await _.chiamataAxios(
        "GET",
        "/mgmt/listTranslations/" +
          _.typeList[_.type].code +
          "/" +
          _.lang +
          "/" +
          _.filter
      );
      _.translations = response.data;
    },
  },
  mounted() {
    let _ = this;
    _.pilotLang = window.selectedLanguage;
    _.systemData = window.systemData;
    _.lang = _.computedLanguageList[0].language;
    this.loadData();
  },
};
</script>

<style type="text/css">
.appContainer {
  margin: 10px 20px;
}
</style>